export default "__VITE_ASSET__CIzy7uOl__"